import { InvestmentAllocation } from '../types/pension-calculator.type';
import { RiskProfileRange } from '../types/risk-profile.type';
import { General } from '../types/general.type';
import { Role } from '../types/role.type';

export const GENERAL_CONSTANTS: General = {
  SLASH: '/',
  EMPTY_STRING: '',
  DOT: '.',
  COMMA: ',',
  SEMICOLON: ';',
  COLON: ':',
  DASH: '-',
  UNDERSCORE: '_',
  SPACE: ' ',
  NEWLINE: '\n',
  TAB: '\t',
  QUESTION_MARK: '?',
  EXCLAMATION_MARK: '!',
  QUOTE: "'",
  DOUBLE_QUOTE: '"',
  OPEN_PARENTHESIS: '(',
  CLOSE_PARENTHESIS: ')',
  OPEN_BRACKET: '[',
  CLOSE_BRACKET: ']',
  OPEN_BRACE: '{',
  CLOSE_BRACE: '}',
  PERCENTAGE: '%',
};

export const CURRENCY_CONSTANTS: any = {
  RP: 'Rp',
}

export const FILE_TYPE_CONSTANTS: any = {
  XLS: 'xls',
  XLSX: 'xlsx',
  CSV: 'csv',
}

export const ROLE_CONSTANTS: Role = {
  ROLE_EMPLOYEE: 'pA7qRrD3OcbtjAUmwKuJ5A==',
  ROLE_EMPLOYER: 'PgZgwVDYuHRwWlI023sGDg==',
  ROLE_ADMIN: 'oiPZXGpe+L1gjjGHi3XNGA==',
  ROLE_SUPPORT: 'yE1kX6egFMOLZH6g3DWZCQ=='
}

export const INVESTMENT_TYPES: InvestmentAllocation[] = [
  {
    investmentType: 1,
    investmentName: 'Money Market Fund',
    percentage: 0,
  },
  {
    investmentType: 2,
    investmentName: 'Fixed Income Fund',
    percentage: 0,
  },
  {
    investmentType: 3,
    investmentName: 'Equity Fund',
    percentage: 0,
  },
  {
    investmentType: 4,
    investmentName: 'USD Fund',
    percentage: 0,
  },
  {
    investmentType: 5,
    investmentName: 'Syariah Fund',
    percentage: 0,
  }
]

export const RISK_PROFILE_RANGE: RiskProfileRange[] = [
  { min: 17, max: 21, riskProfile: 'riskProfile.agg', definition: 'riskProfile.aggDef', investOption: 'riskProfile.investOptionAgg' },
  { min: 12, max: 16, riskProfile: 'riskProfile.mod', definition: 'riskProfile.modDef', investOption: 'riskProfile.investOptionMod' },
  { min: 7, max: 11, riskProfile: 'riskProfile.consrv', definition: 'riskProfile.consrvDef', investOption: 'riskProfile.investOptionConsrv' }
]